// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrap {\n  border: 1px solid #ccc;\n  margin-top: 10px;\n}\n.wrap .toolbar {\n  border-bottom: 1px solid #ccc;\n}\n.wrap .editor {\n  height: 400px;\n  overflow-y: hidden;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
